<template>
  <div class="container">
    <breadcrumb></breadcrumb>
    <div class="option-wrap">
      <Select v-model="search.bigPluginType" style="width: 100px;" placeholder="插件分类" @on-change="loadData">
        <Option value="">全部</Option>
        <Option value="sdk">sdk</Option>
        <Option value="apk">apk</Option>
      </Select>
    </div>
    <div class="select-box input_left">
      <Input v-model="search.pluginTitle" style="width:100px;" placeholder="插件名称"/>
    </div>
    <div class="select-box input_left_two">
      <!-- <Input v-model="search.pkgName" style="width:150px;" placeholder="请输入宿主包名" /> -->
      <Select v-model="search.pluginType" style="width: 100px;" placeholder="插件类型">
        <Option :value="-1">全部</Option>
        <Option :value="0">droidplugin</Option>
        <Option :value="1">virtualApp</Option>
      </Select>
      <Select v-model="search.status" style="width: 100px;margin-left:25px;margin-right:25px;" placeholder="审核状态">
        <Option value="">全部</Option>
        <Option :value="0">待审核</Option>
        <Option :value="1">审核通过</Option>
        <Option :value="2">审核驳回</Option>
      </Select>
      <all-user ref="allUser" :type="'all'" @usernameChange="usernameChange"></all-user>
    </div>
    <div class="select-box input_left_three">
      <Button type="primary" @click="searchBtn" style="margin-right:5px;">查询</Button>
      <Button type="primary" @click="searchClear">重置</Button>
    </div>
    <div class="select-box-type-pl">
      <Select v-model="plType" style="width:150px" @on-change="changePlType" placeholder="请选择批量操作">
        <Option value="1" key="1">批量通过</Option>
        <Option value="2" key="2">批量拒绝</Option>
      </Select>
    </div>
    <Table :loading="tableLoading" class="spacingTwice" border @on-selection-change="tableOnSelect" :columns="columns" :data="dataList"></Table>
    <Page v-show="total > 10" show-total :total="total" :current="current" :page-size="pageSize"
          @on-change="pageChange" @on-page-size-change="pageSizeChange" show-sizer />
    <Modal :mask-closable="false"
           v-model="checkdata"
           title="审核驳回"
           :loading="loading"
           @on-cancel="cancelReason"
           @on-ok="editData('formValidate')">
      <Form ref="formValidate" :model="formValidate" :rules="ruleValidate" :label-width="120">
        <FormItem label="驳回理由" prop="reason">
          <Input type="textarea" placeholder="请输入驳回理由，限制50字" v-model="formValidate.reason" maxlength="50" />
        </FormItem>
      </Form>
    </Modal>
    <Modal :mask-closable="false"
           v-model="isShowInfo"
           :footer-hide="true"
           title="详情">
      <Form ref="formApkInfo" :model="formApkInfo" :label-width="120">
        <FormItem label="插件版本号" prop="pluginVerName">
          <Input v-model="formApkInfo.pluginVerName" :disabled="true" placeholder="插件版本号" />
        </FormItem>
        <FormItem label="插件版本包" prop="pluginVerName">
          <!-- <Input v-model="formApkInfo.pluginVerName" :disabled="true" placeholder="插件版本号" /> -->
          <a target=“_blank” :href="zipUrl+ formApkInfo.apkPath">下载</a>
        </FormItem>
        <FormItem label="版本编号" prop="pluginVerCode">
          <Input v-model="formApkInfo.pluginVerCode" :disabled="true" placeholder="版本编号" />
        </FormItem>
        <!-- <FormItem label="宿主版本" prop="storeVerCodes">
          <Input v-model="formApkInfo.storeVerCodes" :disabled="true" placeholder="宿主版本" />
        </FormItem> -->
        <FormItem label="更新说明" prop="remarks">
          <Input v-model="formApkInfo.remarks" :disabled="true" placeholder="备注最大字数为50字" maxlength="50" type="textarea" :rows="4" />
        </FormItem>
      </Form>
    </Modal>
    <Modal
           v-model="isShowMac"
           @on-cancel="closeModal"
            @on-ok="editDataMac('formApkMac')"
           title="定投设备">
      <Form ref="formApkMac" :model="formApkMac" :label-width="120">
        <FormItem label="设备mac地址" prop="macs">
          <Input v-model="formApkMac.macs" placeholder="多个mac地址请用英文逗号隔开 示例：ecfa5cbc6aaf" type="textarea" :rows="5" />
        </FormItem>
      </Form>
    </Modal>
    <Modal
      width="600"
      :mask-closable="false"
      v-model="plPush"
      title="批量通过"
      @on-ok="editDataPL(false)"
      @on-cancel="cancelModal"
      >
      是否将{{this.tableSelectRow.length}}个版本插件通过审核
    </Modal>
    <Modal
      width="600"
      :mask-closable="false"
      v-model="plPublish"
      title="批量拒绝"
      @on-ok="editDataPL(true)"
      @on-cancel="cancelModal"
      >
      <p>是否将{{this.tableSelectRow.length}}个版本插件拒绝审核</p>
      <Form ref="formValidatePl" :model="formValidatePl" :label-width="120">
        <FormItem label="驳回理由" prop="reason">
          <Input type="textarea" placeholder="请输入驳回理由，限制50字" v-model="formValidatePl.reason" maxlength="50" />
        </FormItem>
      </Form>
    </Modal>
  </div>
</template>

<script>
import breadcrumb from '@/components/global/breadcrumb'
import allUser from '@/components/global/allUser'
import https from '../../https'
import utils from '../../utils'
export default {
  name: 'checkApp',
  data () {
    return {
      loading: true,
      tableLoading: true,
      checkdata: false,
      authorized: false,
      isShowInfo: false,
      isShowMac: false,
      selectItems: [],
      sdkVersion: [],
      plType: 0,
      plPush: false,
      plPublish: false,
      check: [
        { name: '待审核', val: 0 },
        { name: '审核通过', val: 1 },
        { name: '审核驳回', val: 2 }
      ],
      search: {
        // aduit_stats: 9
        bigPluginType: '',
        pluginTitle: '',
        status: '',
        pluginType: '',
        createBy: ''
        // pluginTitle: '测试'
      },
      formApkInfo: {},
      formApkMac: {},
      formValidate: {
        pluginId: '',
        status: '',
        reason: '',
        id: '',
        bigPluginType: ''
      },
      formValidatePl: {
        reason: ''
      },
      editFlag: true,
      ruleValidate: {
        aduit_con: [
          { required: false, message: '请输入应用名称', trigger: 'blur' },
          { type: 'string', max: 50, message: '最多输入50个字', trigger: 'blur' }
        ]
      },
      dataSource: [], // table数据源
      columns: [ // table表格
        {
          type: 'selection',
          width: 60,
          align: 'center'
        },
        {
          title: '用户名',
          key: 'userName',
          width: 200,
          align: 'center'
        },
        {
          title: '插件分类',
          key: 'bigPluginType',
          align: 'center',
          width: 90
        },
        {
          title: '审核状态',
          key: 'status',
          align: 'center',
          width: 150,
          render: (h, params) => {
            let checked = ''
            this.check.forEach(n => {
              if (n.val === params.row.status) checked = n.name
            })
            let html = [
              h('span', checked)
            ]
            if (params.row.status === 2 && params.row.reason) {
              html.push(h('Tooltip', {
                props: {
                  placement: 'bottom',
                  content: params.row.reason
                }
              }, [
                h('Icon', {
                  props: {
                    type: 'ios-help-circle-outline'
                  },
                  style: {
                    color: '#f00'
                  }
                })
              ]))
            }
            return h('div', html)
          }
        },
        {
          title: '插件名称',
          key: 'pluginTitle',
          width: 200,
          align: 'center'
        },
        {
          title: '插件类型',
          key: 'pluginType',
          width: 150,
          align: 'center',
          render: (h, params) => {
            let status = ''
            switch (params.row.pluginType) {
              case '-1':
                status = 'droidplugin | virtualApp'
                break
              case '0':
                status = 'droidplugin'
                break
              case '1':
                status = 'virtualApp'
                break
            }
            let html = [
              h('span', status)
            ]
            return html
          }
        },
        {
          title: '版本名称',
          key: 'pluginVerName',
          align: 'center',
          width: 150
        },
        {
          title: '版本号',
          key: 'pluginVerCode',
          align: 'center',
          width: 100
        },
        // {
        //   title: '宿主版本',
        //   key: 'storeVerCodes',
        //   align: 'center',
        //   width: 150,
        //   render: (h, params) => {
        //     let status = ''
        //     if (params.row.storeVerCodes.length > 0) {
        //       status = params.row.storeVerCodes
        //     } else {
        //       status = '全部'
        //     }
        //     let html = [
        //       h('span', status)
        //     ]
        //     return html
        //   }
        // },
        {
          title: '更新说明',
          key: 'remarks',
          align: 'center',
          width: 100
        },
        {
          title: '创建时间',
          key: 'createTime',
          align: 'center',
          width: 200
        },
        {
          title: '审核时间',
          key: 'updateTime',
          align: 'center',
          width: 200
        },
        {
          title: '操作人',
          key: 'updateBy',
          align: 'center',
          width: 200
        },
        {
          title: '操作',
          width: 300,
          align: 'center',
          fixed: 'right',
          render: (h, params) => {
            return h('div', [
              h('Button', {
                props: {
                  type: 'success',
                  size: 'small'
                },
                style: {
                  marginRight: '5px'
                },
                on: {
                  click: () => {
                    this.isShowInfo = true
                    this.formApkInfo = params.row
                  }
                }
              }, '详情'),
              h('Button', {
                props: {
                  type: 'success',
                  size: 'small',
                  disabled: (params.row.status === 1 || params.row.status === 2)
                },
                style: {
                  marginRight: '5px'
                },
                on: {
                  click: () => {
                    this.editData(1, params.row)
                  }
                }
              }, '通过'),
              h('Button', {
                props: {
                  type: 'error',
                  size: 'small',
                  disabled: (params.row.status === 1 || params.row.status === 2)
                },
                style: {
                  marginRight: '5px'
                },
                on: {
                  click: () => {
                    this.checkdata = true
                    this.formValidate.status = 2
                    this.formValidate.id = params.row.id
                    this.formValidate.bigPluginType = params.row.bigPluginType
                    this.formValidate.pluginId = params.row.pluginId
                    // this.editData(2, params.row)
                  }
                }
              }, '拒绝'),
              h('Button', {
                props: {
                  type: 'success',
                  size: 'small'
                },
                on: {
                  click: () => {
                    this.formApkMac = params.row
                    this.isShowMac = true
                    // this.editData(2, params.row)
                  }
                }
              }, '定投设备')
            ])
          }
        }
      ],
      tableSelectRow: [],
      tvpList: [],
      dataList: [], // tab当前页数据
      total: 0, // tab总条数
      pageSize: 10, // 每页多少条
      current: 1, // 当前页
      zipUrl: 'http://qcloudcdn.a311.ottcn.com/'
    }
  },
  components: {
    breadcrumb,
    allUser
  },
  created () {
    if (!https.token) {
      this.$router.push('/')
      return
    }
    // this.zipUrl = utils.zipUrl
    this.loadData()
  },
  methods: {
    formatDay: utils.formatDay,
    searchBtn () {
      this.loadData()
    },
    searchClear () {
      this.search = {
        bigPluginType: '',
        pluginTitle: '',
        status: '',
        pluginType: '',
        createBy: ''
      }
      this.$refs.allUser.clear()
      this.loadData()
    },
    usernameChange (val) {
      this.search.createBy = val
      this.loadData()
    },
    changePlType () {
      // console.log(this.tableSelectRow)
      if (this.plType === '1') {
        // audit_status
        console.log('批量通过')
        this.plPush = true
      } else if (this.plType === '2') {
        console.log('批量继绝')
        this.plPublish = true
      }
    },
    cancelModal () {
      this.plType = 0
    },
    tableOnSelect (row) {
      this.tableSelectRow = this.unique(this.tableSelectRow.concat(row))
    },
    unique (arr) {
      const res = new Map()
      return arr.filter((r) => !res.has(r.id) && res.set(r.id, 1))
    },
    editDataPL (type) {
      if (this.tableSelectRow.length === 0) {
        this.plType = 0
        this.$Message.error('请先选择应用')
        return
      }
      let params = []
      this.tableSelectRow.map(item => {
        if (type) {
          params.push({
            id: item.id,
            status: this.plType,
            bigPluginType: item.bigPluginType,
            reason: this.formValidatePl.reason
          })
        } else {
          params.push({
            id: item.id,
            status: this.plType,
            bigPluginType: item.bigPluginType
          })
        }
      })
      https.request({
        method: 'post',
        url: 'extscreenapi/plugin/hili/esPluginVersionVerify/batchVerify',
        data: params
      }).then(res => {
        this.plType = 0
        this.loadData()
        this.tableSelectRow = []
      }).catch(error => {
        this.$Message.error(error)
      })
    },
    updateChecked () {
      for (var i = 0; i < this.dataSource.length; i++) {
        this.dataSource[i]._checked = false
        if (this.dataSource[i].status === 1 || this.dataSource[i].status === 2) {
          this.dataSource[i]._disabled = true
        }
        for (var j = 0; j < this.tableSelectRow.length; j++) {
          if (this.tableSelectRow[j].id === this.dataSource[i].id) {
            this.dataSource[i]._checked = true
          }
        }
      }
    },
    // 加载tabs列表
    loadData () {
      https.request({
        method: 'get',
        // url: '/v1/check/app',
        url: '/extscreenapi/plugin/hili/esPluginVersionVerify/list',
        params: {
          ...this.search,
          pageNo: this.current,
          pageSize: this.pageSize,
          column: 'createTime',
          order: 'desc'
        }
      }).then(res => {
        this.tableSelectRow = []
        this.tableLoading = false
        // this.dataSource = res.result.records || []
        this.total = res.result.total
        // this.current = res.result.current
        // this.pageSize = res.result.pages
        // this.setData()
        // this.dataList = res.result.records || []
        this.getUserNameFun(res.result.records || [])
      }).catch(error => {
        this.$Message.error(error)
      })
    },
    getUserNameFun (list) {
      let arr = []
      list.map(item => {
        arr.push(item.createBy)
      })
      let str = arr.join(',')
      https.request({
        method: 'get',
        url: `getUsernamesByIds?ids=${str}`,
        params: {}
      }).then(res => {
        res.data.map(item => {
          list.map(sItem => {
            if (item.value === sItem.createBy) {
              sItem['userName'] = item.text
            }
          })
        })
        this.dataList = list
        this.dataSource = list
        this.updateChecked()
      })
    },
    // 数据静态分页
    setData () {
      this.dataList = []
      for (let i = (this.current - 1) * this.pageSize; i < this.current * this.pageSize; i++) {
        if (i === this.total) return false
        this.dataList.push(this.dataSource[i])
      }
      setTimeout(() => {
        this.updateChecked()
      }, 2000)
    },
    // 表格排序
    sortChange (data) {
      if (data.order !== 'normal') {
        this.sort = [data.key, data.order].join(' ')
        this.loadData()
      }
    },
    // 页数切换
    pageChange (page) {
      this.current = page
      this.loadData()
    },
    // 每页条数控制
    pageSizeChange (size) {
      this.pageSize = size
      this.current = 1
      this.loadData()
    },
    cancelReason () {
      this.$refs['formValidate'].resetFields()
    },
    editData (type = 1, row = {id: 0}) {
      console.log(row)
      let params = {
        status: type,
        id: row.id,
        pluginId: row.pluginId,
        bigPluginType: row.bigPluginType
      }
      if (this.formValidate.status === 2) {
        params.status = this.formValidate.status
        params.id = this.formValidate.id
        params.reason = this.formValidate.reason
        params.bigPluginType = this.formValidate.bigPluginType
        params.pluginId = this.formValidate.pluginId
      }
      https.request({
        method: 'post',
        url: 'extscreenapi/plugin/hili/esPluginVersionVerify/verify',
        data: params
      }).then(res => {
        if (res.code === 500) {
          this.$Message.success(res.message)
          return
        }
        this.checkdata = false
        this.$refs['formValidate'].resetFields()
        this.formValidate = {
          aduit_stats: '',
          reason: '',
          id: '',
          bigPluginType: ''
        }
        this.$Message.success('提交成功')
        this.loadData()
      })
    },
    editDataMac (form) {
      this.$refs[form].validate((valid) => {
        if (valid) {
          let params = {
            macs: this.formApkMac.macs,
            id: this.formApkMac.id,
            bigPluginType: this.formApkMac.bigPluginType
          }
          https.request({
            method: 'post',
            url: 'extscreenapi/plugin/hili/esPluginVersionVerify/setMacs',
            data: params
          }).then(res => {
            this.$Message.success('提交成功')
            this.loadData()
          })
        }
      })
    },
    closeModal () {
      this.isShowMac = false
      this.formApkMac = {}
    },
    changeLoading () {
      this.loading = false
      this.$nextTick(() => {
        this.loading = true
      })
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
.container{
  position: relative
}
  .file-wrap {
    position: relative;
    display: inline-block;
    .file-input {
      position: absolute;
      top: 0;
      left: 0;
      z-index: 1;
      width: 100%;
      height: 100%;
      opacity: 0;
    }
  }
  .select-box{
    display: flex;
    position: absolute;
    top: 67px;
    right: 160px;
    .select-label{
      line-height: 32px;
      margin-right: 10px;
    }
  }
  .select-box-type{
    display: flex;
    position: absolute;
    top: 20px;
    right: 60px;
  }
  .select-box-type-pl{
    display: flex;
    position: absolute;
    top: 20px;
    left: 153px;
  }
  .input_left{
    left:153px;
    // left:407px;
  }
  .input_left_two{
    left:277px;
    // left:580px;
  }
  .input_left_three{
    left:727px;
    // left:755px;
  }
</style>



// WEBPACK FOOTER //
// src/components/check/checkApk.vue